import React, { Component, Fragment } from 'react';
import '../global';
import { fetchCart, updateCart } from '../actions';
import { connect } from 'react-redux';
import Loading from './loading-component';

class CheckoutPart1 extends Component {

	constructor( props ) {
		super( props );
		this.state = {
			ready       : false,
			showFilters : false,
			isMobile    : false,
			quantities  : {}, // Add this to store quantities for each product
			cartDeleted : false,
			deletedItems: []
		};

		this.cartInfo = getCartInfo();
		this.handleQuantityChange = this.handleQuantityChange.bind( this );
		// this.props.fetchCart();
	}

	componentDidMount() {
		// Wait for loading to be done before initializing quantities
		this.waitForLoadingToFinish().then( () => {
			// Initialize quantities with default values from products
			const initialQuantities = {};
			if ( this.props.cart && this.props.cart.products ) {
				this.props.cart.products.forEach( product => {
					initialQuantities[ product.iMIS_code ] = product.quantity;
				} );
			}
			this.setState( { quantities: initialQuantities } );
		} );
	}

	componentDidUpdate() {
		this.updateCartQuantityDisplay();
	}

	async waitForLoadingToFinish() {
		while ( this.props.loading ) {
			await new Promise( resolve => setTimeout( resolve, 100 ) );
		}
	}

	handleQuantityInputChange( event, iMIS_code ) {
		const { value } = event.target;
		this.setState( prevState => ({
			quantities: {
				...prevState.quantities, [ iMIS_code ]: value
			}
		}
		) );
	}

	//   handleQuantityChange(event, iMIS_code, change = null) {
	// 	if (event && event.key === 'Enter') {
	// 		event.preventDefault(); // Prevent form submission on Enter key
	// 		return;
	// 	}
	// 	if (change !== null) {
	// 	  // For button clicks
	// 	  this.setState(prevState => {
	// 		const newQuantity = Math.max(1, (prevState.quantities[iMIS_code] || 1) + change);
	// 		const newQuantities = {
	// 		  ...prevState.quantities,
	// 		  [iMIS_code]: newQuantity
	// 		};

	// 		this.updateCart(newQuantities);

	// 		return { quantities: newQuantities };
	// 	  });
	// 	} else {
	// 	  // For manual input
	// 	  const { name, value } = event.target;
	// 	  const productCode = name.match(/\[(.*?)\]/)[1];
	// 	  this.setState(prevState => {
	// 		const newQuantity = Math.max(1, parseInt(value, 10) || 1);
	// 		const newQuantities = {
	// 		  ...prevState.quantities,
	// 		  [productCode]: newQuantity
	// 		};

	// 		this.updateCart(newQuantities);

	// 		return { quantities: newQuantities };
	// 	  });
	// 	}
	//   }

	handleQuantityChange( event, iMIS_code, change = null ) {
		if ( event && event.key === 'Enter' ) {
			event.preventDefault(); // Prevent form submission on Enter key
			return;
		}

		let newQuantity;

		if ( change !== null ) {
			// For button clicks
			newQuantity = Math.max( 1, (this.state.quantities[ iMIS_code ] || 1
			                           ) + change );
		} else {
			// For manual input (on blur)
			newQuantity = Math.max( 1, parseInt( event.target.value, 10 ) || 1 );
		}
		this.setState( prevState => {
			const newQuantities = {
				...prevState.quantities, [ iMIS_code ]: newQuantity
			};

			this.updateCart( newQuantities );

			return { quantities: newQuantities };
		} );
	}

	updateCart( newQuantities ) {
		// Create an object with iMIS_code as key and quantity as value
		const items = this.props.cart.products.reduce( ( acc, product ) => {
			acc[ product.iMIS_code ] = newQuantities[ product.iMIS_code ] || 1;
			return acc;
		}, {} );

		// Log the items object for debugging
		localStorage.setItem( 'bookstoreCart', JSON.stringify( items ) );
		this.props.updateCart( items );
	}

	updateCartQuantityDisplay() {
		const totalQuantity = Object.values( this.state.quantities )
		                            .reduce( ( sum, quantity ) => sum + parseInt( quantity, 10 ) || 0, 0 );
		const cartQuantityElements = document.querySelectorAll( '.cart-quantity' );
		cartQuantityElements.forEach( element => {
			element.textContent = totalQuantity.toString();
		} );
	}

	getBookstoreBannerMessage() {

		if ( this.props.cart.products && this.props.cart.products.length > 0 && ( this.cartInfo.library_status === 'PLUS' || this.cartInfo.library_status === 'LIB' ) ) {
			return (<div class="alert alert-warning" id="bookstore-cart-ol-msg">
					Did you mean to buy this? Remember that as an Online Library
					subscriber you can download books for free by clicking the
					"Online Library" tab in the Bookstore.
				</div>
			);
		}
		return null;
	}

	handleRemoveItem( iMIS_code ) {
		//get all cart items but remove the one with the iMIS_code
		const items = this.props.cart.products.reduce( ( acc, item ) => {
			if ( item.iMIS_code !== iMIS_code ) {
				acc[ item.iMIS_code ] = item.quantity;
			}
			return acc;
		}, {} );
		this.setState( {
			               deletedItems: [
				               ...this.state.deletedItems, iMIS_code
			               ]
		               } );
		localStorage.setItem( 'bookstoreCart', JSON.stringify( items ) );
		this.props.updateCart( items );
	}

	emptyCart() {
		localStorage.removeItem( 'bookstoreCart' );
		this.setState( { cartDeleted: true } );
		this.props.updateCart( {} );
	}

	renderProducts() {
		if ( this.props.cart.products && this.props.cart.products.length > 0 && !this.state.cartDeleted ) {
			return this.props.cart.products.filter( product => !this.state.deletedItems.includes( product.iMIS_code ) )
			           .map( ( product ) => (<div key={ product.id }
			                                      className="row no-gutter line-item item-row">
					           { product.product_type === 'On Demand' && (<div
							           className="col-xs-6 col-sm-4 col-product-info">
							           { product.thumbnail }
							           <p className="product-title">{ product.title }</p>
							           <p className="product-type visible-xs">{ product.product_type }</p>
						           </div>
					           ) }
					           <div
						           className={ `col-xs-6 col-sm-4 col-product-info book-category-${ product.category } ${ product.text_color }` }>
						           <div className="bookstore-cover-wrap">
							           <div
								           className={ `bookstore-cover category-${ product.category } cover-checkout ${ product.type === 'On Demand' ? 'on-demand-cover' : '' }` }>
								           <h3 className="bookstore-cover__title title-checkout ellipsis-title"
								               aria-hidden="true">
									           { product.type === 'On Demand' ? 'On Demand' : (product.display_title || product.title) }
								           </h3>

										   { product.type === 'On Demand' && (<>
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
												<path d="M8.0001 3H9.0001C7.0501 8.84 7.0501 15.16 9.0001 21H8.0001" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
												<path d="M15 3C16.95 8.84 16.95 15.16 15 21" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
												<path d="M3 16V15C8.84 16.95 15.16 16.95 21 15V16" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
												<path d="M3 8.99998C8.84 7.04998 15.16 7.04998 21 8.99998" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>

												<svg width="39" height="14" viewBox="0 0 39 14" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M9.93297 13.5668C9.50287 13.5668 9.07276 13.5668 8.64266 13.5668C7.68382 13.4766 7.11096 13.0164 6.19551 12.8848C5.91965 12.9615 6.10337 13.4787 5.79506 13.5242C5.74927 12.5994 5.66344 11.2671 5.83956 10.4127C6.12024 11.1034 6.37181 11.7418 6.9519 12.2883C7.77726 13.0653 9.42964 13.5751 10.7784 12.9278C11.9754 12.3533 12.3842 10.4988 11.4013 9.34748C9.82878 7.50528 5.61208 7.3664 6.01753 3.72125C6.24204 1.70234 8.35104 0.339825 10.8228 0.779907C11.1719 0.842066 11.588 1.09034 11.9797 1.03565C12.3286 0.986984 12.2075 0.790208 12.5136 0.652039C12.593 1.02943 12.5581 1.52954 12.5581 2.01597C12.5581 2.49743 12.6662 3.05597 12.4244 3.33728C12.0816 1.99519 11.1651 0.884334 9.35456 1.07827C7.4239 1.28517 6.44745 3.90648 7.84177 5.38319C8.99657 6.60629 11.7109 7.17957 12.7361 8.7504C14.1502 10.9174 12.2072 13.4746 9.93297 13.5668Z" fill="white"/>
												<path d="M32.5798 0.779846C33.6688 3.69597 34.8444 7.0385 36.0056 10.1997C36.4105 11.3004 36.7665 13.0787 38.1858 13.1831C37.9713 13.4167 37.5466 13.3112 37.2072 13.3112C36.2068 13.3112 34.8536 13.3799 33.9589 13.2261C34.313 13.0212 34.8501 13.1897 35.1158 12.9702C35.6575 12.523 34.9593 11.1296 34.7598 10.5837C34.4174 9.64738 34.1766 8.93522 33.9589 8.28202C32.4758 8.28202 30.9927 8.28202 29.5096 8.28202C29.2624 8.87892 29.0654 9.60724 28.7532 10.4982C28.413 11.4688 27.6785 13.184 29.2871 13.2263C28.4708 13.3959 27.152 13.3117 26.2617 13.2687C26.3796 13.0391 26.7387 13.0796 26.9736 12.9277C27.7613 12.4188 28.08 11.0619 28.4419 10.0296C29.4897 7.03921 30.5848 3.70485 31.601 0.90807C31.5971 0.847688 31.5935 0.787305 31.6453 0.780201C31.9571 0.779846 32.2684 0.779846 32.5798 0.779846ZM29.6432 7.81246C30.9927 7.7844 32.461 7.86929 33.7365 7.77019C32.9895 5.87151 32.3759 3.84497 31.6008 1.97329C30.9673 3.93767 30.304 5.874 29.6432 7.81246Z" fill="white"/>
												<path d="M0.5 0.907741C1.84853 0.962796 3.41712 0.796566 4.59342 0.992987C4.25638 1.13524 3.61752 1.25831 3.39209 1.63233C3.08694 2.13919 3.21411 3.43386 3.21411 4.31758C3.21411 6.30985 3.21411 8.11724 3.21411 10.0717C3.21411 11.5738 3.05468 12.6351 4.015 13.0128C4.22356 13.0947 4.51833 13.0944 4.59342 13.2684C3.31793 13.368 1.84964 13.2828 0.5 13.311C0.5 13.2544 0.5 13.1972 0.5 13.1404C1.28661 13.1258 1.78513 12.7493 1.87912 11.9897C2.04356 10.6668 1.87912 8.94092 1.87912 7.13069C1.87912 5.32135 2.02762 3.69759 1.87912 2.27168C1.7981 1.49043 1.31182 1.10185 0.5 1.07823C0.5 1.0214 0.5 0.964572 0.5 0.907741Z" fill="white"/>
												<path d="M14.3374 13.2686C14.3459 13.0581 14.6663 13.146 14.8268 13.0981C15.7864 12.8127 15.6724 11.7866 15.6724 10.3704C15.6724 8.46409 15.6724 6.49545 15.6724 4.57351C15.6724 3.64504 15.781 2.12375 15.4944 1.63252C15.218 1.15887 14.7432 1.13188 14.3376 0.993177C14.3303 0.943628 14.3474 0.917344 14.3821 0.907931C17.629 0.955527 20.6672 0.641183 22.8804 1.5899C24.9376 2.47184 26.5465 4.15669 26.7513 6.70465C26.9977 9.76836 25.4721 11.7113 23.3255 12.7145C21.1288 13.7408 17.5522 13.1904 14.3374 13.2686ZM17.0515 9.90137C17.0515 10.8206 16.9312 12.0029 17.3185 12.4584C17.951 13.2023 21.0367 12.9788 22.1238 12.5864C23.8427 11.9665 25.0498 10.0298 25.194 8.15348C25.5541 3.46371 22.1835 0.389174 17.0515 1.5471C17.0515 4.31084 17.0515 7.06748 17.0515 9.90137Z" fill="white"/>
												<path d="M38.142 11.1798C39.14 11.0434 39.035 12.6151 38.0084 12.3734C37.46 12.2439 37.3678 11.2856 38.142 11.1798ZM38.409 11.2652C37.3504 10.9853 37.6407 12.8359 38.5427 12.1601C38.8919 11.8983 38.7564 11.3567 38.409 11.2652Z" fill="white"/>
												<path d="M38.5424 12.1601C38.2995 12.1509 38.3727 11.8396 38.1419 11.8192C38.0416 11.8511 38.1243 12.0582 38.0976 12.1601C37.8336 12.1287 38.0199 11.6662 37.9639 11.4356C38.1454 11.3384 38.4997 11.3915 38.5424 11.5636C38.5572 11.7201 38.4741 11.782 38.3644 11.8192C38.43 11.927 38.5216 12.0097 38.5424 12.1601ZM38.0976 11.7337C38.2441 11.7323 38.4124 11.7515 38.4091 11.606C38.4029 11.4839 38.2235 11.5283 38.0976 11.5208C38.0976 11.592 38.0976 11.6629 38.0976 11.7337Z" fill="white"/>
												</svg>
										   </>) }
							           </div>
									   {product.type !== 'On Demand' && (
							           <svg
								           className="bookstore-cover__bookmark"
								           xmlns="http://www.w3.org/2000/svg"
								           width="20" height="20"
								           viewBox="0 0 20 20" fill="none">
								           <path
									           d="M2.37417 19.625C2.82921 19.8195 3.33229 19.8723 3.8178 19.7765C4.3033 19.6808 4.74868 19.441 5.09584 19.0883L10 14.2108L14.9042 19.0883C15.1328 19.3203 15.4052 19.5047 15.7056 19.6307C16.006 19.7567 16.3284 19.8219 16.6542 19.8225C16.989 19.8215 17.3204 19.7544 17.6292 19.625C18.0879 19.4393 18.48 19.1197 18.7543 18.7077C19.0286 18.2958 19.1723 17.8107 19.1667 17.3158V4.16667C19.1653 3.062 18.7259 2.00296 17.9448 1.22185C17.1637 0.440735 16.1047 0.00132321 15 0L5 0C3.89534 0.00132321 2.8363 0.440735 2.05519 1.22185C1.27407 2.00296 0.834659 3.062 0.833336 4.16667V17.3158C0.827958 17.8111 0.97215 18.2964 1.24706 18.7084C1.52196 19.1204 1.91479 19.4399 2.37417 19.625Z"
									           fill="#C6A57D"/>
							           </svg>
							           )}
						           </div>
						           <div className="bookstore-info">
							           <h3 className="book-title title-checkout">
								           <a href={ `${ product.permalink }${ product.is_library
								                                               ? '?library/'
								                                               : '' }` }
								              data-bookid={ product.id }>
									           { product.title }
								           </a>
							           </h3>
						           </div>
					           </div>
					           <div
						           className="col-xs-3 col-sm-2 col-product-qty">
						           <label>
				  <span className="sr-only">
					Quantity for { product.title }
				  </span>
							           <div className="quantity-control">
								           <select
									           className="product-qty-field"
									           name={ `products[${ product.iMIS_code }]` }
									           value={ this.state.quantities[ product.iMIS_code ] || product.quantity }
									           onChange={ ( e ) => product.is_physical ? this.handleQuantityChange( e, product.iMIS_code ) : null }
									           // onBlur={(e) => this.handleQuantityChange(e, product.iMIS_code)}
									           disabled={ this.props.loading || !product.is_physical }
								           >
									           { [
										           ...Array( Math.max( 10, this.state.quantities[ product.iMIS_code ] || product.quantity ) )
											           .keys()
									           ].map( i => (
										           <option key={ i + 1 }
										                   value={ i + 1 }>{ i + 1 }</option>
									           ) ) }
								           </select>
							           </div>
						           </label>
					           </div>
					           <div
						           className="col-xs-4 col-sm-3 col-product-prices">
						           <span aria-hidden="true">&#36;</span>
						           <span
							           className="price member-price">{ product.price_member } </span>
						           |
						           <span aria-hidden="true"> $</span>
						           <span
							           className="price nonmember-price">{ product.price_nonmember }</span>
						           <button
							           className="btn btn-link remove-item visible-xs"
							           data-imiscode={ product.iMIS_code }
							           onClick={ () => this.handleRemoveItem( product.iMIS_code ) }>
							           Remove
						           </button>
					           </div>
					           <div
						           className="hidden-xs col-sm-1 col-product-format">
						           <p className="product-type">{ product.type }</p>
					           </div>
					           <div
						           className="hidden-xs col-sm-2 col-product-remove">
						           <div type="button"
						                className={`btn btn-link remove-item ${this.props.loading && 'disabled'}`}
						                data-imiscode={ product.iMIS_code }
						                onClick={ () => !this.props.loading && this.handleRemoveItem( product.iMIS_code ) }>
							           <i className="fa-regular fa-trash-can"></i>
						           </div>
					           </div>
				           </div>
			           ) );
		}

		return (<div>
				{ this.props.loading ? (<div className="col-xs-12">
						<Loading width="100%" height="25"/>
					</div>
				) : (<div className="cart-empty-row">
						<div className="alert alert-warning">
							<p>Your cart is empty.</p>
						</div>
						<div className="row no-gutter cart-total-row">
							<div
								className="cart-cta-buttons">
								<a className="btn btn-primary" href="/books">Continue
									Shopping</a>
							</div>
						</div>
					</div>
				  ) }
			</div>
		);
	}

	render() {

		return (<div className="col-md-8 col-lg-9">
				{ this.getBookstoreBannerMessage() }

				<div>
					<div class="back-to-btn back-to-cart-container">
						<div class="back-to-btn back-to-shopping">
							<a href="/books">
								<button class="back-to-shopping-button">
									<i class="fa fa-arrow-left"
									   aria-hidden="true"></i>
									Continue Shopping
								</button>
							</a>
						</div>

					</div>
					<form id="bookstore-cart" action="" method="post">
						<div class="row cart-title-row no-gutter">
							<div class="col-xs-6 col-sm-4">
								Product Details
							</div>
							<div class="col-xs-2">
								<span class="visible-xs">Qty</span>
								<span class="hidden-xs">Quantity</span>
							</div>
							<div class="col-xs-4 col-sm-3">
								<span class="visible-xs visible-sm">Price</span>
								<span class="hidden-xs hidden-sm">Price <br/>( member | non-member )</span>
							</div>
							<div class="col-sm-1 hidden-xs">
								Format
							</div>
							{/* <div class="col-sm-1 hidden-xs">
							 Edit
							 </div> */ }
						</div>
						{ this.renderProducts() }
					</form>
					<div>
						{ !this.state.cartDeleted && !this.props.loading && this.props.cart.products
						  ? <div className="clear-cart-container ">
							  <button className="clear-entire-cart-btn"
							          onClick={ () => this.emptyCart() }>
								  <i className="fa-regular fa-trash-can"
								     aria-hidden="true"
								     style={ { fontWeight: 100 } }></i>
								  <div class="btn-link"
								       onClick={ () => this.emptyCart() }>

									  Clear Cart
								  </div>
							  </button>
						  </div>
						  : null }

					</div>
				</div>

			</div>
		);
	}
}

function mapStateToProps( { cart, loading } ) {
	return {
		cart, loading
	};
}

export default connect( mapStateToProps, {
	fetchCart, updateCart
} )( CheckoutPart1 );